export default __webpack_public_path__ + "static/media/FlagSpain.243e63a3.jpg";